import { render, staticRenderFns } from "./sortBox.vue?vue&type=template&id=22affeed&scoped=true"
import script from "./sortBox.vue?vue&type=script&lang=js"
export * from "./sortBox.vue?vue&type=script&lang=js"
import style0 from "./sortBox.vue?vue&type=style&index=0&id=22affeed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22affeed",
  null
  
)

export default component.exports